import { useHightouchOrganization } from 'api/HightouchAPI';
import { selectFeatureFlags } from 'core/userContext';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HightouchBillingQueryContext } from './HightouchBillingQueryContext';

export const HightouchBillingQueryContextProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const { HightouchIntegration } = useSelector(selectFeatureFlags);

  /** Hightouch organization */
  const {
    data: hightouchOrg,
    isError,
    isLoading,
  } = useHightouchOrganization({
    enabled: !!HightouchIntegration,
    onError: (error) => {
      dispatch(
        addNegativeToastWithErrorId(
          'Trouble fetching Smart Ingest details. Please try again, or contact your account manager.',
          'HightouchBillingQueryContextProvider',
          error,
        ),
      );
    },
    refetchOnWindowFocus: false,
    retry: false,
  });

  const value = {
    isError,
    isHightouchEnabled: !!HightouchIntegration,
    isLoading,
    hightouchOrg,
  };
  return (
    <HightouchBillingQueryContext.Provider value={value}>
      {children}
    </HightouchBillingQueryContext.Provider>
  );
};
